<div class="subBlockContainer" id="budgetAlertsEdit">
  <div class="subBlockContent">
    <child-header [title]="budget?.name" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form [formGroup]="budgetAndAlertsForm">

            <!-- Budget Summary -->
            <ng-container>
              <div class="my-4">
                <h6>Budget details</h6>
                <span>Give your budget a unique name. Select the time window it analyzes during each evaluation period, its expiration date and the amount.</span>
                <div class="my-4">

                  <div>
                    <mat-form-field [floatLabel]="'always'">
                      <input
                        matInput
                        formControlName="name"
                        placeholder="Name"
                        required
                      >
                    </mat-form-field>
                  </div>
                  
                  <div *ngIf="budgetAndAlertsForm.get('name').errors?.pattern || !budgetAndAlertsForm.get('name').value" style="padding-bottom: 1.25em; color: red;">
                    * Budget name must only contain alphanumeric, underscore or hyphen.
                  </div> 

                  <div style="padding-bottom: 1.25em;">
                    <mat-form-field>
                      <mat-label>Resets period</mat-label>
                      <mat-select formControlName="timeGrain">
                        <mat-option [value]="'Monthly'">
                          Monthly
                        </mat-option>
                        <mat-option [value]="'Quarterly'">
                          Quarterly
                        </mat-option>
                        <mat-option [value]="'Annually'">
                          Annually
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  
                  <div style="padding-bottom: 1.25em;" class="datepicker-only-month-select">
                    <span>Creation date:</span>
                    <div class="dateIcon" (click)="openDateSelect(dA, 'startDate')">
                      <img src="../images/new_ui/date.png">
                    </div>
                    <input
                      ngbDatepicker
                      (click)="openDateSelect(dA, 'startDate')"
                      class="custom-end-date-input"
                      type="text"
                      [ngClass]="{'dateFieldDisabled': budgetAndAlertsForm.get('startDate').disabled } "
                      placeholder="Creation date"
                      #dA="ngbDatepicker"
                      formControlName="startDate"
                      [markDisabled] = "markDisabled"
                      (navigate)="onCreateDateSelection(null, dA, $event.next)"
                      [minDate]="{year: calendar.getToday().year, month: calendar.getToday().month, day: 1}" readonly>
                  </div>
                    
                  <div style="padding-bottom: 1.25em;">
                    <span>Expiration date:</span>
                    <div class="dateIcon" (click)="openDateSelect(dB, 'endDate')">
                      <img src="../images/new_ui/date.png">
                    </div>
                    <input
                      ngbDatepicker
                      [ngClass]="{'dateFieldDisabled': budgetAndAlertsForm.get('endDate').disabled } "
                      (click)="openDateSelect(dB, 'endDate')"
                      class="custom-end-date-input"
                      type="text"
                      #dB="ngbDatepicker"
                      formControlName="endDate"
                      [minDate]="{year: calendar.getToday().year, month: calendar.getToday().month, day: 1}" readonly>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Budget Alerts -->
            <ng-container>
              <div class="my-4">
                <h6>Budget amount</h6>
                <span>Give your budget amount threshold</span>
                <div class="my-4">
                  <mat-form-field [floatLabel]="'always'">
                    <input matInput
                    type="number" 
                    formControlName="amount"
                      placeholder="Amount" required>
                  </mat-form-field>
                </div>
              </div>
            </ng-container>

            <!-- Alert conditions -->
            <ng-container>
              <div class="my-4">
                <h6>Alert conditions</h6>
                <div class="my-4">
                  <table mat-table style="width: 50%" [dataSource]="budgetDetailDataSrc">
      
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef width="30%">Type</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.type }}
                      </td>
                    </ng-container>
    
                    <ng-container matColumnDef="percent">
                      <th mat-header-cell *matHeaderCellDef width="30%" style="text-align: center !important">% of budget</th>
                      <td mat-cell *matCellDef="let element" class="align-center"> 
                        <input style="width: 80%; font-size: 12px; text-align: center;" formControlName="{{ element.controlName }}">
                      </td>
                    </ng-container>
    
                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef width="30%" style="text-align: center !important">Amount</th>
                      <td mat-cell *matCellDef="let element" style="text-align: center" class="align-center">
                        <span>  {{ budgetAndAlertsForm?.get('amount')?.value * (budgetAndAlertsForm?.get(element.controlName)?.value/100) | currency:'AUD':'symbol-narrow':'.2-2' }} </span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
              </div>
            </ng-container>

            <!-- Alert recipients -->
            <ng-container>
              <div class="my-4">
                <h6>Alert recipients (email)</h6>
                <div class="my-4">
                  <mat-list role="list" style="width: 40%;">
                    <mat-list-item class="dd-list" role="listitem" *ngFor="let e of emails; let i = index">
                        
                      <div style="width: 100%; display: inline-flex;">
                        <span style="width: 100%; font-size: 12px;">{{e}}</span>
                      </div>
                      <i class="material-icons delete-icon-alert-recipient closebutton-pullfloat-right" (click)="deleteEmail(i)">close</i>
                    </mat-list-item>
                    <mat-list-item class="dd-list" role="listitem">       

                      <div style="width: 100%; display: inline-flex;">
                        <input style="width: 100%; font-size: 12px;" formControlName="newEmail">
                      </div>
                    </mat-list-item>
                  </mat-list>
                  
                </div>
                <div *ngIf="!emails?.length" style="padding-bottom: 1.25em; color: red;">
                  * At least one email is mandatory
                </div> 
                <span>It is recommended to add azure-noreply@microsoft.com to your email white list to ensure alert mails do not go to your spam folder.</span>
              </div>
            </ng-container>

            <!-- action buttons -->
            <ng-container>
              <div style="display: inline-flex;">
                <button
                  class="button button-red button-round"
                  (click)="close()"
                >
                  &nbsp;Back&nbsp;
                </button>
          
                <button
                  [disabled]="
                    loading ||
                    !emails?.length ||
                    (budgetAndAlertsForm.get('name').disabled ? false : budgetAndAlertsForm.get('name').invalid) ||
                    !budgetAndAlertsForm.get('amount').valid
                  "
                  class="button button-red button-round"
                  style="margin-left: 15px;"
                  (click)="saveOrCreateButton()"
                >
                  {{ editMode ? '&nbsp;Save&nbsp;' : '&nbsp;Create&nbsp;' }}
                </button>

                <mat-spinner
                  *ngIf="loading"
                  style="margin-left: 15px;"
                  mode="indeterminate"
                  class="circle"
                  diameter="20">
                </mat-spinner>
              </div>
            </ng-container>


          </form>
        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>

</div>
